import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { impactStoryThemes, impactStories } from '../data/impact-stories';

const cardVariants = {
    offscreen: { opacity: 0, y: 50 },
    onscreen: {
        opacity: 1,
        y: 0,
        transition: { type: "spring", bounce: 0.3, duration: 0.8 }
    }
};

const OurImpact = ({ darkMode }) => {
    const cardStyle = {
        backgroundColor: darkMode ? '#343a40' : '#ffffff',
        color: darkMode ? '#f8f9fa' : '#212529',
        border: darkMode ? '1px solid #495057' : '1px solid #dee2e6'
    };

    return (
        <Container style={{ minHeight: '100vh', paddingTop: '30px', paddingBottom: '30px' }}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h2 className="text-center mb-3" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                    Our Impact
                </h2>
                <p className="text-center mb-5" style={{ maxWidth: '900px', margin: '0 auto', fontSize: '1.1rem' }}>
                    Over nearly two decades, PSGS has transformed the lives of thousands across rural
                    Maharashtra through its integrated approach to women's empowerment, environmental
                    restoration, water security, and climate resilience. From pioneering grassroots initiatives to
                    leading state-level partnerships, PSGS continues to strengthen rural systems and promote
                    sustainable development.
                </p>
            </motion.div>

            <Row>
                {impactStoryThemes.map((theme, index) => {
                    const story = impactStories[theme.id];
                    return (
                        <Col md={6} lg={4} key={theme.id} className="mb-4">
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.2 }}
                                variants={cardVariants}
                                style={{ height: '100%' }}
                            >
                                <Card style={cardStyle} className="shadow-sm h-100">
                                    <Card.Img
                                        variant="top"
                                        src={story.image}
                                        alt={theme.label}
                                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                                    />
                                    <Card.Body className="d-flex flex-column">
                                        <Card.Title style={{ color: darkMode ? '#A5D6A7' : '#2E7D32', fontSize: '1.1rem' }}>
                                            {theme.label}
                                        </Card.Title>
                                        <Card.Text className="flex-grow-1" style={{ fontSize: '0.95rem' }}>
                                            {story.sections[0].content.substring(0, 150)}...
                                        </Card.Text>
                                        <Link
                                            to={`/our-impact/${theme.id}`}
                                            className="btn mt-2"
                                            style={{
                                                backgroundColor: '#2E7D32',
                                                color: '#ffffff',
                                                border: 'none',
                                                alignSelf: 'flex-start'
                                            }}
                                        >
                                            Read Full Story
                                        </Link>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
};

export default OurImpact;
